import styled from "@emotion/styled/macro";
import { Modal, Typography } from "@sunrun/experience-ui-components";
import { tokens } from "@sunrun/experience-ui-components";
import { Card } from "@sunrun/experience-ui-components";
import { Button } from "@sunrun/experience-ui-components";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";
import { Box } from "components/atoms/Box";

type CustomerAppTaskModalProps = {
  name: string;
  email: string;
  phone: string;
  onClose: () => void;
  onSendEmail: () => void;
};

const CustomerAppTaskModal = ({
  name,
  email,
  phone,
  onClose,
  onSendEmail,
}: CustomerAppTaskModalProps) => {
  return (
    <StyledModal
      testId="customer-app-task-modal"
      customModalWidth={720}
      onClose={onClose}
      hideIcon
    >
      <Box marginBottom="32px">
        <Typography variant="h1" size={tokens.FONT_SIZE_8}>
          Send customer app link
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap="16px">
        <Typography size={tokens.FONT_SIZE_3} fontWeight="medium">
          Contact information
        </Typography>
        <Card>
          <Typography>{name}</Typography>
          <Box display="flex">
            <Box display="flex" flex="1" flexDirection="column" gap="4px">
              <Typography color={tokens.TINTS_OFF_WHITE_20}>Phone</Typography>
              <Typography>{phone}</Typography>
            </Box>
            <Box display="flex" flex="1" flexDirection="column" gap="4px">
              <Typography color={tokens.TINTS_OFF_WHITE_20}>Email</Typography>
              <Typography>{email}</Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <ButtonContainer display="flex" marginTop="40px" gap="24px">
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" onClick={onSendEmail}>
          Send email
        </Button>
      </ButtonContainer>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .modal-container > div:first-child {
    padding-bottom: 0;
  }

  .modal-container > div:last-child {
    padding-top: 0 !important;
  }
`;

const ButtonContainer = styled(Box)`
  flex-direction: row;
  justify-content: flex-end;

  @media (max-width: ${mobileMaxWidth}px) {
    flex-direction: column;
    justify-content: center;
    & > .sr-button-md:first-child {
      order: 3;
    }

    & > .sr-button-md:last-child {
      order: 1;
    }

    & > .sr-button-md:nth-child(2) {
      order: 2;
    }
  }
`;

export type { CustomerAppTaskModalProps };
export { CustomerAppTaskModal };
